import DownloadFileComponent from './DownloadFileComponent';
export default DownloadFileComponent;
